import React, { useEffect, useState } from 'react';
import { Link } from '@reach/router';
import { database, auth } from '../modules/fireBase';
import { Layout, Menu, Breadcrumb } from 'antd';
import '../assets/styles/CustomLayout.css';
import {
  BarChartOutlined,
  CloudOutlined,
  ShopOutlined,
  TeamOutlined,
  UserOutlined,
  UploadOutlined,
  VideoCameraOutlined,
  HomeOutlined,
  FormOutlined,
  AppstoreOutlined,
  SettingOutlined,
  TableOutlined,
  MessageOutlined,
  ReadOutlined,
  DesktopOutlined,
  PieChartOutlined,
  FileOutlined,
} from '@ant-design/icons';

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

export default function CustomLayout(props) {
  const [collapsed, setCollapsed] = useState(true);
  useEffect(() => {}, []);
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={() => {
          setCollapsed(!collapsed);
        }}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'sticky',
          top: 0,
          left: 0,
        }}>
        <div
          className="logo"
          style={{
            marginTop: '15px',
            marginBottom: '15px',
            color: '#fff',
            fontWeight: 'bold',
            fontSize: '20px',
            textAlign: 'center',
          }}>
          Textrr
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[props.selectedKey]}>
          <Menu.Item key="1" icon={<HomeOutlined />}>
            <Link to="/">Accueil</Link>
          </Menu.Item>
          <Menu.Item key="2" icon={<FormOutlined />}>
            <Link to="/planification">Planification</Link>
          </Menu.Item>
          <Menu.Item key="3" icon={<TableOutlined />}>
            <Link to="/planifmultiple">Planification multiple</Link>
          </Menu.Item>
          <Menu.Item key="4" icon={<MessageOutlined />}>
            <Link to="/messagemanuel">Message manuel</Link>
          </Menu.Item>
          <Menu.Item key="5" icon={<TeamOutlined />}>
            <Link to="/carnetadresse">Carnet d'adresse</Link>
          </Menu.Item>
          <Menu.Item key="6" icon={<SettingOutlined />}>
            <Link to="/reglages">Réglages</Link>
          </Menu.Item>
          <Menu.Item key="7" icon={<ReadOutlined />}>
            <Link to="/logs">Logs</Link>
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout className="site-layout" style={{ minHeight: '100vh' }}>
        <Content style={{ margin: '16px', overflow: 'initial' }}>
          <div
            className="site-layout-background"
            style={{ padding: 24, minHeight: '100%', ...props.contentStyle }}>
            {props.children}
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}
